;(function (angular) {
   'use strict'

   angular.module('azure.filters').filter('addressString', addressStringFilter)

   function addressStringFilter($filter) {
      return function (address, includePostalCode) {
         if (!address) {
            return ''
         }

         let addressString

         const maybeExtended = address['extended-address'] && address['extended-address'].trim()
         const maybeStreet = address['street-address'] && address['street-address'].trim()
         const maybeLocality = address.locality && address.locality.trim()

         const tempArray = []
         if (maybeStreet) {
            tempArray.push(maybeStreet)
         }
         if (maybeExtended) {
            tempArray.push(maybeExtended)
         }
         if (maybeLocality) {
            tempArray.push(maybeLocality)
         }

         addressString = tempArray.join(', ')

         if (address.region) {
            if (addressString) {
               addressString += ', ' + $filter('convertPostalStateFormat')(address.region)
            } else {
               addressString += $filter('convertPostalStateFormat')(address.region)
            }

            if (includePostalCode && address['postal-code']) {
               addressString += ' ' + address['postal-code']
            }
         } else if (address.country) {
            addressString += ', ' + address.country
         }

         return addressString
      }
   }
})(angular)
